import { RequireAuth } from '@/routes/guards';
import { TourAutoTrigger } from '@/providers/TourProvider';
import { AppShell } from './AppShell';

// Layout wrapper para usar como `element` de las rutas autenticadas.
// Combina el guard de sesión con el shell visual (sidebar + navbar + outlet).
//
// Uso típico desde el router:
//   { element: <ProtectedLayout />, children: [...rutas privadas] }
export const ProtectedLayout = () => {
  return (
    <RequireAuth>
      <TourAutoTrigger />
      <AppShell />
    </RequireAuth>
  );
};
